import List from "@mui/icons-material/List";
import LooksOneOutlined from "@mui/icons-material/LooksOneOutlined";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import classNames from "classnames";
import { useCallback } from "react";
import PageHeader from "./PageHeader";

function NewAssetPageHeader({
  singleAsset,
  setSingleAsset,
}: {
  singleAsset: boolean;
  setSingleAsset: React.Dispatch<React.SetStateAction<boolean>>;
}) {
  const PageToolbarComponent = useCallback(
    () => (
      <div className="flex items-center gap-2 border rounded-lg p-1 h-full">
        <Tooltip
          title="Tous les documents constituent un même dossier"
          placement="top"
        >
          <Button
            onClick={() => setSingleAsset(true)}
            className={classNames(
              "flex items-center gap-1 px-3 py-1.5 rounded",
              {
                "bg-blue-100 text-blue-700": singleAsset,
                "text-gray-600 hover:bg-gray-100": !singleAsset,
              }
            )}
          >
            <LooksOneOutlined className="w-4 h-4" />
            <span>Unique</span>
          </Button>
        </Tooltip>
        <Tooltip
          title="Chaque document constitue un dossier séparé"
          placement="top"
        >
          <Button
            onClick={() => setSingleAsset(false)}
            className={classNames(
              "flex items-center gap-1 px-3 py-1.5 rounded",
              {
                "bg-blue-100 text-blue-700": !singleAsset,
                "text-gray-600 hover:bg-gray-100": singleAsset,
              }
            )}
          >
            <List className="w-4 h-4" />
            <span>Multiple</span>
          </Button>
        </Tooltip>
      </div>
    ),
    [singleAsset, setSingleAsset]
  );
  return (
    <PageHeader
      title="Créer un nouveau dossier"
      breadcrumbs={[
        { title: "Dossiers", path: "/orion/assets" },
        {
          title: "Nouveau dossier",
          path: `/orion/asset/new`,
        },
      ]}
      slots={{ toolbar: PageToolbarComponent }}
    />
  );
}

export default NewAssetPageHeader;
